import { getDateVal } from "@/pages/dashboard/utils/utils";
import { DATE_FILTER_ARR } from "./_config";

const conutryKeyList = [
  "region_country",
];

const getFilterValue = (value: any, filter: any) => {
  const { options, default: defaultValue, key, type } = filter || {};
  const filterKey = type || key;
  const valueList: any = [];
  options?.forEach((item: any) => {
    if (conutryKeyList?.includes(filterKey)) {
      item?.children?.forEach((child: { value: any; }) => {
        valueList.push(child?.value);
      });
    } else {
      valueList.push(item?.value);
    }
  });

  // 处理国家value(对象格式)
  if (conutryKeyList?.includes(filterKey)) {
    // 过滤掉没有在options中的值
    const filterValue = value?.market?.filter((v: any) => valueList?.includes(v));
    const newValue = filterValue?.length > 0 ? {
      ...value,
      market: filterValue
    } : defaultValue;
    return newValue;
  }
  // 其他类型直接赋值
  // 过滤掉没有在options中的值
  const newValue = value?.filter((v: any) => valueList?.includes(v));
  // 过滤后没值，使用默认值兜底
  return newValue?.length > 0 ? newValue : defaultValue;
};

export const getSaveValue = (config: { dateType?: string; durationType?: string; value?: any; }, inputList: any[]) => {
  const { dateType, durationType, value } = config || {};
  const saveValue: any = {};
  inputList?.forEach((item: any) => {
    const { key, type, shortcutOption } = item;
    const filterKey = type || key;
    // 没有key值，直接返回
    if (!filterKey) return;
    // 日期类型筛选器，需要格式化
    if (DATE_FILTER_ARR?.includes(filterKey)) {
      // dateDuration类型时间推理
      try {
        if (dateType === "dateDuration" && shortcutOption?.length > 0 && durationType) {
          const shortcut = shortcutOption?.find((item: any) => item?.type === durationType);
          if (shortcut) {
            return saveValue[filterKey] = shortcut?.duration();
          }
        }
      } catch (error) {
        console.log(error);
      }
      // 固定日期直接返回
      return saveValue[filterKey] = value[key]?.map((date: any) => getDateVal(date));
    }
    // 其他类型直接赋值
    saveValue[filterKey] = getFilterValue(value[filterKey], item);
  });
  return saveValue;
};